import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./ProductSlider.css";
import { baseURl } from "../../config";
import { setRelatedProducts } from "../../store/slice";
import { useDispatch, useSelector } from "react-redux";
import { fetchRelaPro } from "../util";

const ProductSlider = ({ product }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [extractedProducts, setExtractedProducts] = useState([]);
  const { products, relatedProds } = useSelector((state) => state.data);

  const sliderRef = useRef(null);
  const [shouldCenter, setShouldCenter] = useState(false);

  let location = "";
  if (product.subCategorySlug) {
    location = `/Products/${product?.categorySlug}/${product?.subCategorySlug}/${product?.productSlug}`;
  } else {
    location = `/Products/${product?.categorySlug}/${product?.productSlug}`;
  }
  const pathParts = location.split("/").filter(Boolean);

  useEffect(() => {
    setExtractedProducts(relatedProds);
  }, [relatedProds]);

  useEffect(() => {
    const checkFit = () => {
      if (sliderRef.current) {
        const containerWidth = sliderRef.current.clientWidth; // Visible width of the container
        const totalCardsWidth = extractedProducts.length * 295; // Each card width (280px + 15px gap)

        setShouldCenter(totalCardsWidth <= containerWidth);
      }
    };

    checkFit(); // Run initially
    window.addEventListener("resize", checkFit); // Listen for window resize

    return () => window.removeEventListener("resize", checkFit); // Cleanup event listener
  }, [extractedProducts.length]);

  const handleProductClick = (product) => {
    localStorage.setItem("selectedProductId", product._id);
    if (pathParts.length > 3) {
      dispatch(setRelatedProducts(fetchRelaPro(products, pathParts[1], pathParts[2], product.productSlug)));

      navigate(`/Products/${pathParts[1]}/${pathParts[2]}/${product.productSlug}`, {
        state: { product },
      });
    } else {
      dispatch(setRelatedProducts(fetchRelaPro(products, pathParts[1], "yyyyyyyyy", product.productSlug)));

      navigate(`/Products/${pathParts[1]}/${product.productSlug}`, {
        state: { product },
      });
    }
  };

  // Ensure at least 4 cards by adding placeholders
  const minCards = 0;
  const placeholdersNeeded = Math.max(0, minCards - extractedProducts.length);
  const placeholders = Array.from({ length: placeholdersNeeded }).map((_, index) => (
    <div key={`placeholder-${index}`} className="product-card2 placeholder-card">
      <div className="product-image-container">
        <div className="placeholder-image"></div>
      </div>
      <div className="product-info">
        <h3 className="placeholder-title">Coming Soon</h3>
      </div>
    </div>
  ));

  return (
    <>
      <div className="product-slider-container">
        <h2 className="slider-title">
          Explore More <span>Products</span>
        </h2>
        <div
          className="product-slider"
          ref={sliderRef}
          style={{
            justifyContent: shouldCenter ? "center" : "flex-start",
            overflowX: shouldCenter ? "hidden" : "auto",
          }}
        >
          {extractedProducts.map((product) => (
            <div key={product._id} className="product-card2" onClick={() => handleProductClick(product)}>
              <div className="product-image-container">
                <img
                  src={`${baseURl}/${product.productImage}`}
                  alt={product.prodName}
                  className="product-image"
                  onError={(e) => {
                    console.error(`Image failed to load: ${e.target.src}`);
                    e.target.src = "/placeholder-image.jpg";
                  }}
                />
              </div>
              <div className="product-info">
                <h3 className="product-title2">{product.prodName}</h3>
              </div>
            </div>
          ))}
          {placeholders}
        </div>
      </div>
    </>
  );
};

export default ProductSlider;
